<template>
  <div class="join">
    <div class="content" @click.stop>
      <!-- Exclusive Privilege -->
      <h3 class="column-title">Exclusive Privilege</h3>
      <div class="privilege">
        <div class="privilege-item" v-for="item in privilegeList" :key="item.icon">
        <img :src="require(`@/assets/images/icon/privilege-${item.icon}.png`)" alt="" />
        <span>{{ item.title }}</span>
        </div>
      </div>
      <!-- VIP Featured Comics -->
      <div class="vip-area">
        <h3 class="column-title">VIP Featured Comics</h3>
        <List :data="vipSuggestList" :displayStyle="7" @goDetail="goDetail" />
      </div>
      <div class="btn" @click.stop="handleClick">
        <img src="@/assets/images/button/join.png" alt="" />
      </div>
    </div>
    <div class="close" @click.stop="handleClose"></div>
  </div>
</template>
<script>
import { getVipSuggest, getNovelChapters } from '@/api';
import List from '@/components/List';

export default {
  components: {
    List,
  },
  created() {
    this.init();
  },
  data() {
    return {
      vipSuggestList: [],
      privilegeList: [
        { title: 'Unlock All Chapters', icon: '01' },
        { title: 'Editors\' Choice', icon: '02' },
        { title: 'Read In Advance', icon: '03' },
      ],
    };
  },
  methods: {
    async init() {
      const data = await getVipSuggest();
      const vipSuggestList = Object.values(data?.data || {});
      this.vipSuggestList = vipSuggestList?.[0]?.items || [];
    },
    async goDetail(novelId) {
      const res = await getNovelChapters(novelId);
      if (res.code !== 0) return;
      const { id = '' } = res.data[0];
      this.handleClose('all');
      this.$router.push(`/novel/${novelId}/chapter/${id}`);
    },
    handleClose(str = '') {
      this.$emit('close', str);
    },
    handleClick() {
      this.handleClose('all');
      this.$router.push('/premium');
    },
  },
};
</script>
<style lang="less" scoped>
.join {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  .content {
    background: url('@/assets/images/bg/join.png') center no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 85%;
    padding: 138px 20px 0;
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      background: url('@/assets/images/icon/join.png') center no-repeat;
      background-size: 100% 100%;
      width: 274px;
      height: 252px;
      position: absolute;
      top: -30px;
      right: 0;
    }
    .btn {
      width: 218px;
      height: 44px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .column-title {
      font-size: 20px;
      font-weight: 700;
      color: #4ecaa8;
      padding: 0 20px 4px;
      text-align: center;
      display: flex;
      justify-content: space-between;
      white-space: nowrap;
      &::before, &::after {
        content: '';
        width: 50px;
        flex-shrink: 0;
        background: url('~@/assets/images/bg/join-title.png') center no-repeat;
        background-size: 100%;
      }
      &::after {
        transform: rotateY(180deg);
      }
  }
  .privilege {
      display: flex;
      padding: 0 16px;
      justify-content: space-between;
      margin-bottom: 16px;
      .privilege-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 52px;
          height: 52px;
        }
        span {
          line-height: 24px;
          font-size: 14px;
          text-align: center;
        }
      }
  }
  .close {
    width: 22px;
    height: 22px;
    background: url('@/assets/images/icon/close-circle.png') center no-repeat;
    background-size: 100% 100%;
    margin-top: 25px;
  }
  .vip-area {
    /deep/ .por-auto {
      padding-top: 0;
      .inner {
        justify-content: flex-start;
      }
      .item {
        width: 80px;
        .title {
          font-size: @fontSmall;
        }
        img {
            height: 106px;
            width: 80px;
        }
      }
    }
  }
}
</style>
